import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import { moveOfflineOrderToCartForEdit } from "utils"
import classes from "./OfflineOrderDetailsEditButton.module.scss"

const OfflineOrderDetailsEditButton = props => {
  const { offlineOrder } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const handlePress = () => {

    moveOfflineOrderToCartForEdit(offlineOrder)

    history.push("/foods")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"]
      )}
    >
      <Button
        color="warning"
        fullWidth onClick={handlePress}
      >
        {t("ویرایش")}
      </Button>
    </div>
  )
}

export default OfflineOrderDetailsEditButton